
import { defineComponent } from "vue";

export default defineComponent({
    name: "v-icon",
    props: {
        source: {
            type: String,
            required: true,
        },
        href: {
            type: String,
            required: false,
        },
        width: {
            type: Number,
            required: false,
            default: 24,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        getSource() {
            return require("@/assets/" + this.source);
        },
        redirect() {
            if(this.href != null && !this.disabled)
            {
                this.$router.push(this.href);
            }
        },   
        getWidth() {
            return this.width + 'px';
        },
    },
});
